import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import AuthLayout from '../components/AuthLayout';
import Seo from '../components/Seo';
import Icon from '../components/Icon';

export default function Register() {
  const { t, i18n } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) setReferralCode(ref);
  }, [searchParams]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError(t('auth.err_weak_password'));
      return;
    }
    setBusy(true);
    try {
      // Bir yayıncının referans linkiyle geldiyse (PublishersLanding.jsx'te
      // ?pref= yakalanıp buraya kadar taşınır) — customer referralCode'dan
      // BAĞIMSIZ bir alan, ikisi karışmasın diye.
      const pubRef = localStorage.getItem('vokelle_pubref') || undefined;
      await register({
        email,
        password,
        displayName: displayName || undefined,
        referralCode: referralCode || undefined,
        pubRef,
        preferredLanguage: i18n.resolvedLanguage,
      });
      if (pubRef) localStorage.removeItem('vokelle_pubref');
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(t([`auth.err_${err.code}`, 'auth.err_generic']));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout>
      <Seo title={t('auth.register_title')} description="Vokelle hesabı oluşturun ve private server'ınızı izlemeye başlayın." />
      <div className="auth-head">
        <h1>{t('auth.register_title')}</h1>
        <p className="sub">{t('auth.register_sub')}</p>
      </div>

      {error && (
        <div className="form-error">
          <Icon name="alert-triangle" size={15} style={{ marginTop: 1, flexShrink: 0 }} />
          {error}
        </div>
      )}

      <form onSubmit={submit} noValidate>
        <div className="field">
          <label htmlFor="email">{t('common.email')}</label>
          <div className="control">
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" placeholder="siz@sunucunuz.com" />
          </div>
        </div>
        <div className="field">
          <label htmlFor="password">{t('common.password')}</label>
          <div className="control">
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" placeholder="••••••••" />
          </div>
          <div className="hint">{t('auth.password_hint')}</div>
        </div>
        <div className="field">
          <label htmlFor="displayName">{t('auth.display_name')}</label>
          <div className="control">
            <input id="displayName" type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
          </div>
        </div>
        <div className="field">
          <label htmlFor="ref">{t('auth.referral_code')}</label>
          <div className="control">
            <input id="ref" type="text" value={referralCode} onChange={(e) => setReferralCode(e.target.value)} placeholder="VOK-…" />
          </div>
        </div>
        <button className="btn btn-block" disabled={busy}>
          {busy ? `${t('common.loading')}…` : t('auth.register_action')}
        </button>
      </form>

      <div className="auth-alt">
        {t('auth.have_account')} <Link to="/login">{t('auth.login_action')}</Link>
      </div>
    </AuthLayout>
  );
}
